import ElectricityIcon from "../../../images/electricty.svg"
import WaterIcon from "../../../images/water.svg"
import GasIcon from "../../../images/gas.svg"
import MobileIcon from "../../../images/mobile.svg"
import TelephoneIcon from "../../../images/telephone.svg"
const BillTypes={
    water:{
        billType:"Water",
        parameterLabel:"شناسه قبض",
        title:"قبض آب",
        shortName:"آب",
        icon:WaterIcon,
    },
    tel:{
        billType:"TelBills",
        parameterLabel:"شماره تلفن",
        title:"قبض تلفن",
        shortName:"تلفن",
        icon:TelephoneIcon,
    },
    mobile:{
        billType:"MobileBills",
        parameterLabel:"شماره موبایل",
        title:"قبض موبایل",
        shortName:"موبایل",
        icon:MobileIcon,
    },
    electricity:{
        billType:"Electricity",
        parameterLabel:"شناسه قبض",
        title:"قبض برق",
        shortName:"برق",
        icon:ElectricityIcon,
    },
    gas:{
        billType:"GasByBillId",
        parameterLabel:"شناسه قبض",
        title:"قبض گاز",
        shortName:"گاز",
        icon:GasIcon,
    }
}
export default BillTypes;